module.exports = __webpack_public_path__ + "img/bg-about.1893d744.webp";